/* tslint:disable */

/**
 */
export class TicketTypeInput {
    style_search?: string;
    key_input?: string;
}
